export default __webpack_public_path__ + "click-button-f92baf2084d328b032691bc234dabb9c.wav";